module.exports = __webpack_public_path__ + "img/3min_exam.08ade766.png";